<template>
  <div class="main table-box">
    <global-tag>
      <el-form label-width="120px" :model="queryInfo">
        <div class="searchBox">
          <div class="content">
            <el-row>
              <el-col :span="5">
                <el-form-item label="机构名称：">
                  <el-input
                    clearable
                    v-model.trim="queryInfo.statName"
                    style="width: 100%"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="机构类型：">
                  <el-select
                    clearable
                    style="width: 100%"
                    v-model="queryInfo.statType"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in typeOptions"
                      :key="item.dictCode"
                      :label="item.dictLabel"
                      :value="item.dictCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="btn">
            <el-button type="primary" @click="querySearch" class="searchBtns"
              >查询
            </el-button>
          </div>
        </div>
      </el-form>
    </global-tag>
    <div class="table_title">
      <div class="btn_group">
        <el-button
          type="success"
          class="openBtns"
          size="mmedium"
          @click="addServices('新增', 'add')"
          >新增
        </el-button>
        <el-button
          type="primary"
          class="downOutBtns"
          size="mmedium"
          @click="createExcel"
          >导出数据
        </el-button>
        <!-- <div style="display: none">
            <input @change="fileChange" id="speechUpload" type="file" />
        </div>
        <label for="speechUpload" class="labelImportBtn">
            <span>导入</span>
        </label> -->
      </div>
    </div>
    <div class="table_container">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        height="550px"
        :header-cell-style="{
          background: '#e6e6e6',
          color: '#000',
        }"
        border
      >
        <el-table-column
          type="index"
          width="70"
          label="序号"
          align="center"
          v-if="this.tempTableChekbox.findIndex((item) => item == '序号') != -1"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="机构编码"
          align="center"
          prop="statNum"
          v-if="
            this.tempTableChekbox.findIndex((item) => item == '机构编码') != -1
          "
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="机构名称"
          align="center"
          prop="statName"
          v-if="
            this.tempTableChekbox.findIndex((item) => item == '机构名称') != -1
          "
          :show-overflow-tooltip="true"
        >
        </el-table-column>

        <el-table-column
          label="机构类型"
          align="center"
          v-if="
            this.tempTableChekbox.findIndex((item) => item == '机构类型') != -1
          "
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <!-- <span v-if="scope.row.statType == 1">居家养老机构</span> -->
            <span v-for="(v,i) in typeOptions" :key="i">
               <span v-if="v.dictCode==scope.row.statType">{{ v.dictLabel }}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="机构电话"
          align="center"
          prop="phone"
          v-if="
            this.tempTableChekbox.findIndex((item) => item == '机构电话') != -1
          "
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="地址"
          align="center"
          prop="address"
          v-if="this.tempTableChekbox.findIndex((item) => item == '地址') != -1"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="240px"
          fixed="right"
          v-if="this.tempTableChekbox.findIndex((item) => item == '操作') != -1"
        >
          <template slot-scope="scope">
            <span @click="addServices('详情', scope.row)" class="operBtn"
              >查看</span
            >
            <span @click="addServices('编辑', scope.row)" class="operBtn"
              >编辑</span
            >
            <!-- <span @click="editArea(scope.row)" class="operBtn"
                >选择服务区域</span
            >
            <span @click="editType(scope.row)" class="operBtn"
                >选择服务类型</span
            > -->
            <span @click="deleteItem(scope.row)" class="operBtn">删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination_container">
      <el-pagination
        :page-size="pageOne.pageSize"
        :current-page.sync="pageOne.pageNo"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageOne.total"
        @size-change="handletableDataSize"
        @current-change="handleTableDataChange"
      ></el-pagination>
    </div>
    <add-service
      v-if="serviceState"
      :openData="serviceInfo"
      @cancleService="cancleService"
      :typeOptions="typeOptions"
    ></add-service>
    <choose-type
      v-if="chooseState"
      :openData="chooseInfo"
      @cancleChoose="cancleService"
    ></choose-type>
    <choose-service
      v-if="typeState"
      :openData="typeInfo"
      @cancleChoose="cancleService"
    ></choose-service>
  </div>
</template>
<script>
import chooseService from "./components/chooseService"
import addService from "./components/addService"
import chooseType from "./components/chooseType"

export default {
  name: "serviceMange",
  inject: ["reload"], //注入
  components: { addService, chooseType, chooseService },
  data() {
    return {
      pageOne: { total: 0, pageSize: 10, pageNo: 1 },
      typeOptions: [],
      tableData: [],
      queryInfo: { statType: "", statName: "" },
      serviceState: false,
      serviceInfo: {},
      typeState: false,
      typeInfo: {},
      chooseState: false,
      chooseInfo: {},
      tempTableChekbox: [
        "序号",
        "机构编码",
        "机构名称",
        "机构类型",
        "机构电话",
        "地址",
        "操作",
      ],
      tableChekbox: [
        "序号",
        "机构编码",
        "机构名称",
        "机构类型",
        "机构电话",
        "地址",
        "操作",
      ],
    }
  },
  created() {
    this.getList()
    this.getType()
  },
  methods: {
    // 当前页
    handleTableDataChange(val) {
      this.pageOne.pageNo = val
      this.getList()
    },
    // 分页大小
    handletableDataSize(val) {
      this.pageOne.pageSize = val
      this.getList()
    },
    getType(){
      let query = {
      pageNum: 1,
      pageSize: 999,
      dictType: "organ_type",
    }
    this.$http
      .request({
        url: "/rbac/system/dict/data/list",
        method: "get",
        params: query,
      })
      .then((res) => {
        if (res.code == 200) {
          if (res.rows != null) {
            this.typeOptions = res.rows
          }
        }
      })
    },
    // 获取数据
    getList() {
      let params = {
        statName: this.queryInfo.statName,
        statType: this.queryInfo.statType,
        pageNo: this.pageOne.pageNo,
        pageSize: this.pageOne.pageSize,
      }
      this.$http
        .request({
          url: "/ypt/admin/serviceStation/info/findList",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.tableData = []
              this.pageOne.total = 0
              return
            }
            if (res.content.list.length > 0) {
              res.content.list.forEach((item) => {
                item.hasChagned = Number(item.counts) - Number(item.stock)
              })
            }
            this.tableData = res.content.list
            this.pageOne.total = res.content.count
          }
        })
    },
    //删除表格信息
    deleteItem(date) {
      let params = {
        id: date.id,
      }
      this.$confirm("确认永久删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http
          .request({
            url: "/ypt/admin/serviceStation/info/deleteById",
            method: "POST",
            data: params,
          })
          .then((res) => {
            if (res.code === 200) {
              this.$message.success(res.message)
              // this.tableData = [];
              this.getList()
            } else {
              this.$message.error(res.message)
            }
          })
      })
    },
    // 选择列的展示方式
    tableChekboxChange(val) {
      this.tempTableChekbox = val.map((item) => item)
    },
    // 取消新增、编辑、查看
    cancleService(state) {
      this.serviceState = false
      this.chooseState = false
      this.typeState = false
      if (state == true) {
        this.getList()
      }
    },

    // 新增\编辑\查看
    addServices(title, row) {
      this.serviceState = true
      this.chooseState = false
      this.typeState = false
      this.serviceInfo = {}
      this.serviceInfo = {
        title: title,
        id: title == "新增" ? "" : row.id,
        state: true,
      }
    },
    // 选择服务区域
    editArea(row) {
      this.serviceState = false
      this.typeState = true
      this.chooseState = false
      this.typeInfo = {}
      this.typeInfo = { id: row.id, state: true }
    },
    // 选择服务类型
    editType(row) {
      this.serviceState = false
      this.typeState = false
      this.chooseState = true
      this.chooseInfo = {}
      this.chooseInfo = { id: row.id, state: true }
    },
    // 页面刷新
    reset() {
      this.reload()
    },
    // 搜索
    querySearch() {
      this.getList()
    },
    //导出excel
    async createExcel() {
      const res = await this.request2({
        url: "/ypt/admin/serviceStation/info/downloadExcel",
        method: "POST",
        data: this.queryInfo,
        responseType: "blob",
      })
      const blob = new Blob([res], { type: "application/vnd.ms-excel" })
      const fileName = "机构管理.xls"
      const linkNode = document.createElement("a")

      linkNode.download = fileName //a标签的download属性规定下载文件的名称
      linkNode.style.display = "none"
      linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
      document.body.appendChild(linkNode)
      linkNode.click() //模拟在按钮上的一次鼠标单击

      URL.revokeObjectURL(linkNode.href) // 释放URL 对象
      document.body.removeChild(linkNode)
    },
    // 导入
    async fileChange(event) {
      console.log(event)
      const file = event.target.files[0]
      console.log(file)
      const personType = "1"
      let config = {
        headers: { "Content-Type": "multipart/form-data" },
      }
      let formData = new FormData()
      formData.append("personType", personType)
      console.log(formData)
      formData.append("file", file)
      let result = await this.$http.post(
        "/ypt/admin/serviceStation/info/excel",
        formData,
        config
      )
      // 清空文件
      const fileEle = document.getElementById("speechUpload")
      fileEle.value = ""
      if (result.code == 200) {
        this.$message.success(result.message)
        this.getList()
      } else {
        this.$message.warning(result.message)
      }
    },
  },
}
</script>
<style lang="less" scoped>
.searchBox {
  display: flex;

  .content {
    flex: 1;
  }
}

/deep/ .table_title {
  margin-top: 15px !important;
}

/deep/ .btn_group {
  margin-top: 0px !important;
}

.button {
  margin-bottom: 4px;
}

.labelImportBtn {
  background: orange;
  border-radius: 3px;
  cursor: pointer;
  margin-left: 10px;
  font-size: 12px;
  padding: 6px 24px;
  color: #fff;
  line-height: 28px;
  display: inline-block;
}

.operBtn {
  cursor: pointer;
  margin-left: 10px;
}
</style>
